import {
  LogoDatabricksIcon,
  LogoBigqueryIcon,
  LogoCloudComposerIcon,
  LogoAirflowIcon,
  LogoLivyIcon,
  LogoProphecyIcon,
  LogoRedshiftIcon,
  LogoSnowflakeIcon,
  LogoSynapseIcon,
  LogoTrinoIcon,
  LogoDataprocIcon,
  LogoEmrIcon,
  LogoMwaaIcon
} from '@prophecy/icons';
import { mapValues } from 'lodash-es';
import React, { ReactNode } from 'react';

import { AIRFLOW_PROVIDER } from '../../constants/airflow';
import { SQL_PROVIDER } from '../../constants/sql';
import { FabricProviderMap, FabricProviderType } from './types';
import { DQ_PROVIDER } from './types/dataQuality';
import { ORCHESTRATION_PROVIDER } from './types/orchestration';
import { SPARK_PROVIDER } from './types/spark';

type SVGIcon = React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
>;

export const FabricSVGIcons: {
  [K in FabricProviderType]: {
    [key in FabricProviderMap[K]]: typeof LogoDatabricksIcon;
  };
} = {
  [FabricProviderType.SQL]: {
    [SQL_PROVIDER.BigQuery]: LogoBigqueryIcon,
    [SQL_PROVIDER.DataBricks]: LogoDatabricksIcon,
    [SQL_PROVIDER.Snowflake]: LogoSnowflakeIcon,
    [SQL_PROVIDER.Trino]: LogoTrinoIcon,
    [SQL_PROVIDER.Redshift]: LogoRedshiftIcon
  },
  [FabricProviderType.Spark]: {
    [SPARK_PROVIDER.DATABRICKS]: LogoDatabricksIcon,
    [SPARK_PROVIDER.PROPHECY]: LogoProphecyIcon,
    [SPARK_PROVIDER.LIVY]: LogoLivyIcon,
    [SPARK_PROVIDER.EMR]: LogoEmrIcon,
    [SPARK_PROVIDER.SYNAPSE]: LogoSynapseIcon,
    [SPARK_PROVIDER.DATAPROC]: LogoDataprocIcon
  },
  [FabricProviderType.Airflow]: {
    [AIRFLOW_PROVIDER.MWAA]: LogoMwaaIcon,
    [AIRFLOW_PROVIDER.CLOUD_COMPOSER]: LogoCloudComposerIcon,
    [AIRFLOW_PROVIDER.PROPHECY_MANAGED_TRIAL]: LogoProphecyIcon,
    [AIRFLOW_PROVIDER.OPEN_SOURCE]: LogoAirflowIcon
  },
  [FabricProviderType.DataQuality]: {
    [DQ_PROVIDER.DATABRICKS]: LogoDatabricksIcon
  },
  [FabricProviderType.Orchestration]: {
    [ORCHESTRATION_PROVIDER.Databricks]: LogoDatabricksIcon,
    [ORCHESTRATION_PROVIDER.Snowflake]: LogoSnowflakeIcon,
    [ORCHESTRATION_PROVIDER.BigQuery]: LogoBigqueryIcon,
    [ORCHESTRATION_PROVIDER.ProphecyManaged]: LogoProphecyIcon
  }
};

export const FabricIcons = mapValues(FabricSVGIcons, (providerIcons) =>
  mapValues(providerIcons as { [key: string]: SVGIcon }, (Icon) => <Icon />)
) as { [K in FabricProviderType]: { [key in FabricProviderMap[K]]: ReactNode } };
